import type { ReactNode } from "react";
import { useEffect, useState } from "react";

/**
 * Default delay used for app-level splash/fallback gating.
 * Keeps fast loads from flashing the splash screen.
 */
export const SPLASH_DELAY_MS = 400;

export function DelayedRender({
  delayMs = SPLASH_DELAY_MS,
  fallback,
}: {
  readonly delayMs?: number;
  readonly fallback: ReactNode;
}) {
  const [shouldRender, setShouldRender] = useState(delayMs <= 0);

  useEffect(() => {
    if (delayMs <= 0) {
      setShouldRender(true);
      return;
    }

    setShouldRender(false);
    const timeoutId = setTimeout(() => setShouldRender(true), delayMs);
    return () => clearTimeout(timeoutId);
  }, [delayMs]);

  return shouldRender ? fallback : null;
}
